"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var Value_1 = __importDefault(require("./Value"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var utils_1 = require("./utils");
var utils_2 = require("../../../utils");
var includesEqual = function (array, item) {
    return array.find(function (i) { return lodash_1.isEqual(i, item); }) !== undefined;
};
var Cell = function (_a) {
    var styles = _a.styles, column = _a.column, row = _a.row, onClick = _a.onClick, rest = __rest(_a, ["styles", "column", "row", "onClick"]);
    return (react_1.default.createElement("td", { style: __assign({}, styles.tbodyTd, utils_1.cellStyle(styles, column)), onMouseDown: onClick },
        react_1.default.createElement(Value_1.default, __assign({}, rest, { row: row, column: column }))));
};
var Row = function (_a) {
    var columns = _a.columns, rowStyleFn = _a.rowStyleFn, styles = _a.styles, item = _a.item, rawItem = _a.rawItem, onRowClick = _a.onRowClick, checkedItems = _a.checkedItems, itemComparator = _a.itemComparator, onCheck = _a.onCheck, rest = __rest(_a, ["columns", "rowStyleFn", "styles", "item", "rawItem", "onRowClick", "checkedItems", "itemComparator", "onCheck"]);
    return (react_1.default.createElement("tr", { style: __assign({}, styles.tbodyTr, rowStyleFn(item, rawItem)) },
        (rest.filterRow || rest.showCheckboxes) && (react_1.default.createElement("td", { style: __assign({}, styles.tbodyTd, { width: 40 }) }, rest.showCheckboxes && (react_1.default.createElement(Checkbox_1.default, { onChange: onCheck, value: checkedItems.find(function (i) { return itemComparator(i, rawItem); }) !== undefined })))),
        columns
            .filter(function (c) { return c.visible !== false; })
            .map(function (column, j) { return (react_1.default.createElement(Cell, __assign({}, rest, { styles: styles, key: j, column: column, row: item, onClick: column.clickable !== false
                ? typeof column.onClick === 'function'
                    ? function (e) { return column.onClick(item, e); }
                    : onRowClick
                : lodash_1.noop }))); })));
};
var RowComposed = recompose_1.compose(recompose_1.pure, utils_1.withStyles, recompose_1.withProps(function (_a) {
    var item = _a.item, rowFunction = _a.rowFunction;
    return ({
        item: rowFunction(item),
        rawItem: item,
    });
}), recompose_1.withHandlers({
    onRowClick: function (props) { return function (event) {
        var onRowClick = props.onRowClick, editItem = props.editItem, item = props.item, editing = props.editing;
        if (typeof onRowClick === 'function') {
            onRowClick(item, event, props);
        }
        else if (editing) {
            editItem(item, event, props);
        }
    }; },
    onCheck: function (_a) {
        var rawItem = _a.rawItem, checkedItems = _a.checkedItems, items = _a.items, itemComparator = _a.itemComparator, dispatch = _a.dispatch, enableMultipleCheck = _a.enableMultipleCheck, shiftDown = _a.shiftDown, firstChecked = _a.firstChecked, setFirstChecked = _a.setFirstChecked;
        return function (value) {
            var getIndex = function (itemToFind) { return (itemToFind ? lodash_1.findIndex(items, function (item) { return itemComparator(item, itemToFind); }) : -1); };
            var uniq = function (items) { return lodash_1.uniqWith(items, itemComparator); };
            var index = getIndex(rawItem);
            var firstCheckedIndex = getIndex(firstChecked);
            var isMultipleCheck = enableMultipleCheck && shiftDown && firstChecked;
            if (value) {
                dispatch(utils_2.createAction('CHECK', isMultipleCheck
                    ? uniq(__spread(checkedItems, items.filter(function (_, i) {
                        return index > firstCheckedIndex
                            ? i <= index && i > firstCheckedIndex
                            : i >= index && i < firstCheckedIndex;
                    })))
                    : __spread(checkedItems, [rawItem])));
                if (enableMultipleCheck && !isMultipleCheck) {
                    setFirstChecked(rawItem);
                }
            }
            else {
                var isSameItem_1 = index === firstCheckedIndex;
                dispatch(utils_2.createAction('CHECK', isMultipleCheck
                    ? checkedItems.filter(function (item) {
                        var i = getIndex(item);
                        return ((!isSameItem_1 || i !== index) &&
                            (index > firstCheckedIndex
                                ? i > index || i <= firstCheckedIndex
                                : i < index || i >= firstCheckedIndex));
                    })
                    : checkedItems.filter(function (i) { return !itemComparator(i, rawItem); })));
                if (enableMultipleCheck && isSameItem_1) {
                    setFirstChecked(null);
                }
            }
        };
    },
}))(Row);
var GroupRow = function (_a) {
    var columns = _a.columns, handleToggleGroup = _a.handleToggleGroup, group = _a.group, styles = _a.styles, item = _a.item, onRowClick = _a.onRowClick, groupRowFormat = _a.groupRowFormat, rest = __rest(_a, ["columns", "handleToggleGroup", "group", "styles", "item", "onRowClick", "groupRowFormat"]);
    return (react_1.default.createElement("tr", { style: styles.tbodyTr },
        react_1.default.createElement("td", { style: __assign({}, styles.tbodyTd, { cursor: 'pointer' }), colSpan: columns.length + rest.showCheckboxes * 1, onClick: handleToggleGroup },
            react_1.default.createElement(Value_1.default, { row: item, column: group }),
            groupRowFormat(item, rest.getGroupItems, group))));
};
var ComposedGroupRow = recompose_1.compose(utils_1.withStyles, recompose_1.withHandlers({
    handleToggleGroup: function (_a) {
        var openedGroups = _a.openedGroups, dispatch = _a.dispatch, item = _a.item, group = _a.group;
        return function () {
            var mapper = group.mapper || lodash_1.identity;
            var mappedItem = mapper(item[group.field]);
            if (includesEqual(openedGroups, mappedItem)) {
                dispatch(utils_2.createAction('GROUP_OPENED', openedGroups.filter(function (i) { return !lodash_1.isEqual(i, mappedItem); })));
            }
            else {
                dispatch(utils_2.createAction('GROUP_OPENED', __spread(openedGroups, [mappedItem])));
            }
        };
    },
}))(GroupRow);
var GridBody = function (props) { return (react_1.default.createElement("tbody", null, props.items.map(function (item, i) { return (react_1.default.createElement(RowComposed, __assign({ key: i, item: item }, props))); }))); };
var GridBodyComposed = recompose_1.compose(recompose_1.withState('shiftDown', 'setShiftDown', false), recompose_1.withState('firstChecked', 'setFirstChecked', null), recompose_1.withHandlers({
    manageKeys: function (_a) {
        var shiftDown = _a.shiftDown, setShiftDown = _a.setShiftDown, setFirstChecked = _a.setFirstChecked;
        return function (e) {
            var shiftKey = e.shiftKey;
            if (shiftKey !== shiftDown) {
                setShiftDown(shiftKey);
                if (!shiftKey) {
                    setFirstChecked(null);
                }
            }
        };
    },
}), recompose_1.lifecycle({
    componentWillMount: function () {
        var manageKeys = this.props.manageKeys;
        document.addEventListener('keyup', manageKeys);
        document.addEventListener('keydown', manageKeys);
    },
    componentWillReceiveProps: function (_a) {
        var items = _a.items, checkedItems = _a.checkedItems;
        var _b = this.props, firstChecked = _b.firstChecked, oldItems = _b.items, setFirstChecked = _b.setFirstChecked;
        if (firstChecked && (!lodash_1.isEqual(oldItems, items) || checkedItems.length === 0)) {
            setFirstChecked(null);
        }
    },
    componentWillUnmount: function () {
        var manageKeys = this.props.manageKeys;
        document.removeEventListener('keyup', manageKeys);
        document.removeEventListener('keydown', manageKeys);
    },
}))(GridBody);
var GroupBody = function (_a) {
    var items = _a.items, rest = __rest(_a, ["items"]);
    return (react_1.default.createElement("tbody", null, items.map(function (item, i) {
        var mapper = lodash_1.identity || rest.group.mapper;
        var mappedItem = mapper(item[rest.group.field]);
        var GroupRow = react_1.default.createElement(ComposedGroupRow, __assign({ key: i, item: item }, rest));
        return includesEqual(rest.openedGroups, mappedItem)
            ? [GroupRow, rest.getGroupItems(item).map(function (it, i) { return react_1.default.createElement(RowComposed, __assign({ key: i, item: it }, rest)); })]
            : [GroupRow];
    })));
};
var Sink = recompose_1.createSink();
exports.default = recompose_1.branch(function (_a) {
    var group = _a.group;
    return !!group;
}, recompose_1.renderComponent(GroupBody), recompose_1.renderComponent(GridBodyComposed))(Sink);
//# sourceMappingURL=Body.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Body.js
// module id = 2213
// module chunks = 0